/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredObjectType
 */
export interface MonitoredObjectType {
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectType
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectType
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectType
     */
    name?: string | null;
}

export function MonitoredObjectTypeFromJSON(json: any): MonitoredObjectType {
    return MonitoredObjectTypeFromJSONTyped(json, false);
}

export function MonitoredObjectTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MonitoredObjectTypeToJSON(value?: MonitoredObjectType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'name': value.name,
    };
}


